module.exports = __webpack_public_path__ + "static/cloud3-24e0a98228dd647983843284481755f6.png";